// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_sy-5";
export var filledCircle = "_sy-4";
export var historyEntry = "_sy-3";
export var messageSideLeft = "_sy-1";
export var messageSideRight = "_sy-2";
export var orderTrackingCarouselWrapper = "_sy-6";
export var orderTrackingInfoContainer = "_sy-0";